<template>
  <div class="register">
    <!-- “register”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @bankBranchChange="bankBranchChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- register -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field === 'fmSendFlag'">
              {{ fmSendFlagList[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'businessType'">
              {{ businessTypeList.find((item) => item.value == scope.row['businessType'])?.label }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      :isShowDownTemplateBtn="true"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/receivablesManage';
  import siruiUpload from '@/components/SiruiUpload';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'registerManage',
    components: {
      siruiUpload,
    },
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司代码
            name: '公司',
            prop: 'registerCompanyCode',
            type: 'select',
            options: this.companyList,
            filterable: true,
          },
          {
            // 收款登记号
            name: this.$t('receivablesManageList.registerColumn.registerNo'),
            prop: 'registerNo',
            type: 'input',
          },
          {
            // 收款状态
            name: this.$t('receivablesManageList.registerColumn.receiveStatus'),
            prop: 'receiveStatus',
            type: 'dict',
            dictType: 'receiveRegisterStatus',
          },
          {
            // 收款方式
            name: this.$t('receivablesManageList.registerColumn.receiveMethod'),
            prop: 'receiveMethod',
            type: 'dict',
            dictType: 'receiveMethod',
          },
          {
            // 付款单位
            type: 'searchTableSpec',
            prop: 'payerCode',
            name: this.$t('receivablesManageList.registerColumn.payerName'),
            searchType: 'partner',
            isMultiple: true,
            extraData: {
              partnerTypes: 'HZHB01,HZHB02,HZHB03', // 客户、供应商、合作伙伴
              companyCode: this.userInfo.userInfo.companyCode,
              departmentCode: this.userInfo.userInfo.departmentCode,
            },
          },
          {
            // 制单人
            type: 'searchTableSpec',
            prop: 'registerCreatePersonNo',
            name: this.$t('receivablesManageList.registerColumn.registerCreatePersonName'),
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            // 收款日期从
            name: this.$t('receivablesManageList.search.registerStartDate'),
            prop: 'registerStartDate',
            type: 'startDaterangePicker',
          },
          {
            // 收款日期到
            name: this.$t('receivablesManageList.search.registerEndDate'),
            prop: 'registerEndDate',
            type: 'endDaterangePicker',
          },
          {
            // 收款金额
            type: 'inputRange',
            prop: ['originReceiveMoneyMinAmount', 'originReceiveMoneyMaxAmount'],
            precision: 2, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('receivablesManageList.registerColumn.originReceiveMoneyAmount'),
            span: 12,
          },
          {
            // 收款银行
            type: 'searchTableSpec',
            prop: 'receiveBankNo',
            name: this.$t('receivablesManage.basicInfo.receiveBankNo'),
            searchType: 'bankAccountBranchName',
            extraData: {
              bankAccountStatus: '001',
              companyCode: this.query.registerCompanyCode,
            },
            isMultiple: true,
            changeMethod: 'bankBranchChange',
          },
          {
            // 收款银行账号
            type: 'input',
            prop: 'receiveBankAccount',
            name: this.$t('receivablesManage.basicInfo.receiveBankAccount'),
            disabled: true,
          },
          {
            // 币种
            type: 'dict',
            prop: 'receiveInfoCurrencyCode',
            name: this.$t('paymentList.table.currencyCode'),
            dictType: 'all_currency',
          },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: {
          amount: [
            'originReceiveMoneyAmount',
            'originProformaInvoiceAmount',
            'originDomesticBankDeductFee',
            'originForeignBankDeductFee',
          ],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        exportAction: API.EXPORT_COLLECTIONREGISTER,
        action: API.IMPORT_COLLECTIONREGISTER,
        templateAction: API.DOWNLOAD_TEMPLATE,
        query: {
          registerCompanyCode: null, // 公司代码
          registerNo: null, // 收款登记号
          receiveStatus: null, // 收款状态
          receiveMethod: null, // 收款方式
          originReceiveMoneyMinAmount: null, // 收款金额
          originReceiveMoneyMaxAmount: null,
          registerCreatePersonNo: null, // 制单人
          registerStartDate: null, // 收款日期
          registerEndDate: null,
          payerCode: null, // 付款单位
          receiveBankNo: null, //收款银行
          receiveBankName: null,
          receiveBankAccount: null,
          searchOrderItems: [],
        },
        fmSendFlagList: ['', '未上报', '已上报'], //上报状态下拉列表
        columnListDefault: [
          {
            // 复选框
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            // 收款登记号
            field: 'registerNo',
            title: 'receivablesManageList.registerColumn.registerNo',
            visible: true,
            width: 150,
            fixed: 'left',
            sortable: true,
          },
          {
            // 收款日期
            field: 'registerDate',
            title: 'receivablesManageList.registerColumn.registerDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          {
            // 付款单位
            field: 'payerName',
            title: 'receivablesManageList.registerColumn.payerName',
            visible: true,
            width: 120,
          },
          {
            // 付款银行
            field: 'payBankName',
            title: 'receivablesManageList.registerColumn.payBankName',
            visible: true,
            width: 120,
          },
          {
            // 付款银行账号
            field: 'payBankAccount',
            title: 'receivablesManageList.registerColumn.payBankAccount',
            visible: true,
            width: 120,
          },
          {
            // 收款方式
            field: 'receiveMethod',
            title: 'receivablesManageList.registerColumn.receiveMethod',
            visible: true,
            width: 120,
            dictType: 'receiveMethod',
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: 'receivablesManageList.registerColumn.originReceiveMoneyAmount',
            visible: true,
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 公司代码
            field: 'registerCompanyName',
            title: 'receivablesManageList.registerColumn.registerCompanyCode',
            visible: true,
            width: 180,
          },
          {
            field: 'businessType',
            title: '业务类别',
            visible: true,
            width: 120,
          },
          {
            // 来源
            field: 'receiveResource',
            title: 'receivablesManageList.registerColumn.receiveResource',
            visible: true,
            width: 120,
            dictType: 'receiveResource',
          },
          /* {
            // 录入日期
            field: 'gmtCreate',
            title: '录入日期',
            visible: true,
            width: 120,
            sortable: true,
          }, */
          {
            // 收款银行
            field: 'receiveBankName',
            title: 'receivablesManageList.registerColumn.receiveBankName',
            visible: true,
            width: 120,
          },
          {
            // 收款银行账号
            field: 'receiveBankAccount',
            title: 'receivablesManageList.registerColumn.receiveBankAccount',
            visible: true,
            width: 120,
          },
          {
            // 银行流水号
            field: 'bankFlowNo',
            title: 'receivablesManageList.registerColumn.bankFlowNo',
            visible: true,
            width: 120,
          },
          {
            // 币种
            field: 'receiveInfoCurrencyName',
            title: 'receivablesManageList.registerColumn.receiveInfoCurrencyCode',
            visible: true,
            width: 120,
          },
          {
            // 制单人
            field: 'registerCreatePersonName',
            title: 'receivablesManageList.registerColumn.registerCreatePersonName',
            visible: true,
            width: 120,
          },
          /* {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title: 'receivablesManageList.registerColumn.originProformaInvoiceAmount',
            visible: true,
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: 'receivablesManageList.registerColumn.originDomesticBankDeductFee',
            visible: true,
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: 'receivablesManageList.registerColumn.originForeignBankDeductFee',
            visible: true,
            width: 120,
            format: 'formatAmount',
            sortable: true,
          }, */
          {
            // 摘要
            field: 'summary',
            title: 'receivablesManageList.registerColumn.summary',
            visible: true,
            width: 120,
          },
          {
            // 收款状态
            field: 'receiveStatus',
            title: 'receivablesManageList.registerColumn.receiveStatus',
            visible: true,
            width: 120,
            dictType: 'receiveRegisterStatus',
            fixed: 'right',
          },
        ],
        companyList: [],
        // 业务列别
        businessTypeList: [
          { label: '贸易', value: '01' },
          { label: '多式联运', value: '02' },
          { label: '园区仓储', value: '03' },
          { label: '园区物业', value: '04' },
          { label: '监管单', value: '05' },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      // 获取列表数据
      async getData() {
        let params = this.setSearchParams();
        // if (!params.registerCompanyCode) {
        //   params.registerCompanyCode = this.userInfo.userInfo.companyCode;
        // }
        this.load = true;
        let res = await this.$axios.post(API.QUERY_COLLECTIONREGISTER_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records.map((item) => {
              if (this.userInfo.userInfo.businessGroup == '物贸' && !item.businessType) {
                item = {
                  ...item,
                  businessType: '01',
                };
              }
              return item;
            });
            // this.$refs.siruiTable.setPageTotal(data.data.total);
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        params.registerCreatePersonNo = params.registerCreatePersonNo
          ? params.registerCreatePersonNo[0].id
          : null;
        params.payerCode = params.payerCode ? params.payerCode[0]?.partnerCode : null;
        return params;
      },
      // 排序
      sortChangeEvent({ property, order }) {
        this.query.searchOrderItems = [
          { column: property.replace(/([A-Z])/g, '_$1').toLowerCase(), asc: order == 'asc' },
        ];
        this.getData();
      },
      bankBranchChange(val) {
        console.log(11);
        val = val.val;
        if (val && val.length > 0 && val[0].branchName) {
          this.query.receiveBankName = val[0].branchName;
          this.query.receiveBankNo = val[0].branchCode;
          this.query.receiveBankAccount = val[0].bankAccountNum;
        } else {
          this.query.receiveBankName = null;
          this.query.receiveBankNo = null;
          this.query.receiveBankAccount = null;
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      // 按钮
      chooseClick(type) {
        // 新增、修改
        if (type === 'add' || type === 'edit') {
          let [name, query] = ['addRegister', {}];
          if (type == 'edit') {
            if (this.multipleSelection.length != 1) {
              return this.tips('onlyOneSelectData', 'warning');
            } else if (
              this.multipleSelection[0].receiveStatus != '00' &&
              this.multipleSelection[0].receiveStatus != '01'
            ) {
              return this.tips('noEdit', 'warning');
            }
            [name, query] = ['editRegister', { id: this.multipleSelection[0].id }];
          }
          this.toPath(name, query);
        } else if (type === 'del') {
          // 删除
          this.handleDel();
        } else if (type == 'batchSubmit') {
          // 批量提交
          this.batchSubmit();
        } else if (type === 'import') {
          // 导入
          this.handleImport();
        } else {
          // 导出
          this.handleExport();
        }
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'warning');
        }
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (['00', '01'].indexOf(i.receiveStatus) != -1) {
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips('noCanSelectRegisterData', 'warning');
        }
        let items = canDelitems.map((i) => i.id);
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message = this.$t('receivablesManageList.message.hasCannotDelRegisterTip');
        }
        this.$confirmAction(this.$t('confirm.delete'), message)
          .then(() => {
            this.commonPost(items, 'DELETE_COLLECTIONREGISTER');
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 重置
      resetBtnClick() {
        console.log('重置');
        this.query = {};
        // this.$refs.siruiTable.page = 1;
        // this.$refs.siruiTable.pageSize = 10;
        if (this.$refs.siruiTable) {
          this.$refs.siruiTable.clearCheckboxReserve();
          this.$refs.siruiTable.clearCheckboxRow();
        }
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 删除
      commonPost(ids, apiName, cancelValidate) {
        this.$axios
          .post(API[apiName] + (cancelValidate ? '?cancelValidate=true' : ''), ids)
          .then((res) => {
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.resetBtnClick();
            } else if (res.data.code === 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.commonPost(ids, apiName, true);
                },
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('detailsRegister', { id: value.row.id });
      },
      // 批量提交
      batchSubmit() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'warning');
        }
        let canSubmitItems = [];
        this.multipleSelection.map((i) => {
          if (i.receiveStatus == '00') {
            canSubmitItems.push(i);
          }
        });
        if (canSubmitItems.length == 0) {
          return this.tips('noCanSelectRegisterData', 'warning');
        }
        let items = canSubmitItems.map((i) => {
          if (this.userInfo.userInfo.businessGroup == '物贸' && !i.businessType) {
            i.businessType = '01';
          }
          return { id: i.id, businessType: i.businessType };
        });
        let message = '';
        if (canSubmitItems.length !== this.multipleSelection.length) {
          message = this.$t('receivablesManageList.message.hasCannotSubmitRegisterTip');
        }
        this.$confirmAction(this.$t('receivablesManageList.message.submit'), message)
          .then(() => {
            this.commonPost(items, `BATCHSUBMIT_COLLECTIONREGISTER`);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true, '04');
      },
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'warning',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManageList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/capital/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
